export enum StoreStatusEnum {
  ALARM = 'Alarm',
  HOBBLED = 'Hobbled',
  RUNNING = 'Running',
  UNAVAILABLE = 'Unavailable',
}
